export default "__VITE_ASSET__CbNz0GzH__"